<template>
  <div class="layout-box">
    <div class="head">
      <Head></Head>
    </div>
    <div class="content globalScroll">
      <router-view />
    </div>
  </div>
</template>
<script>
import Head from "./plugin/head.vue";
export default {
  components: {
    Head
  },
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>
<style lang="less" scoped>
.layout-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 1240px;

  .head {
    width: 100%;
    height: 60px;
    min-height: 60px;
    display: flex;
    justify-content: center;
    box-shadow: 0 4px 6px 0 rgba(113,114,119,0.10);
    z-index: 100;
  }

  .content {
    flex: 1;
    overflow-y: auto;
  }
}
</style>